//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStrapiMedia } from "./../../utils/medias";
import { getMetaTags } from "./../../utils/seo";

export default {
  //Fetching Blog Data
  async asyncData({ $strapi, params }) {
    const matchingArticles = await $strapi.find("blogs", {
      slug: params.slug,
    });
    const banner = await $strapi.find("banner");
    return {
      blog: matchingArticles[0],
      banner,
    };
  },

  data() {
    return {
      apiUrl: process.env.strapiBaseUri,
    };
  },
  methods: {
    getStrapiMedia,
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("en", options);
    },
  },
    head() {
    //Fetching Full Seo Details

    const fullSeo = {
      metaTitle: this.blog.seo ? this.blog.seo.metaTitle : "",
      metaDescription: this.blog.seo ? this.blog.seo.metaDescription : "",
      metaKeywords: this.blog.seo ? this.blog.seo.metaKeywords : "",
      shareImage: this.blog.seo ? this.blog.seo.shareImage.image : "",
    };

    return {
      title: fullSeo.metaTitle,
      meta: getMetaTags(fullSeo),
      link: [
        {
          rel: 'canonical',
          href: process.env.API_URL + this.$route.fullPath
        }
      ]
    };
  },
};
